module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/product-images/product-07-5449abb94cc37bec5f23b086999700a9.webp";